import { TranslationHelper } from '@bcp-channels-sharedcomponents-reactjs/core/dist/helpers';
import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { Anything, Contact } from '@types';

export const usePhonesModal = (): Contact[] => {
	// keep this hook here to update when translations obtained
	useTranslation();
	const phonesResources = TranslationHelper.getByKey('modals.error.phones');
	const phonesModal: Contact[] = (phonesResources?.result as Anything) || [];
	return phonesModal;
};
